(() => {
  if (window.__cpLiveHotfix) return;
  window.__cpLiveHotfix = true;

  const isProductPage = window.location.pathname.indexOf("/products/") === 0;

  const routes = {
    announcement: "/collections/shop-all",
    search: "/search",
  };

  const linkMap = {
    "BEST SELLERS": "/collections/best-sellers",
    "Best Sellers": "/collections/best-sellers",
    "BOOTS": "/collections/dog-boots",
    "Boots": "/collections/dog-boots",
    "HARNESSES": "/collections/dog-harnesses",
    "Harnesses": "/collections/dog-harnesses",
    "PLAYSTACK": "/collections/playstack",
    "PlayStack": "/collections/playstack",
    "Introducing PlayStack": "/collections/playstack",
    "Summer Essentials": "/collections/summer-essentials",
    "Waterproof Dog Clothing": "/collections/waterproof-dog-clothing",
    "Weighted Calm Collection": "/collections/dog-calming",
    "Hands-Free Dog Walking": "/collections/hands-free-dog-walking",
    "Hot Weather Dog Apparel": "/collections/hot-weather-dog-apparel",
    "Last Chance": "/collections/final-sale",
    "Cooling": "/collections/dog-cooling",
    "Collars & Leashes": "/collections/dog-collars-dog-leashes",
    "Toys": "/collections/toys",
    "Life Jackets": "/collections/life-jackets-for-dogs",
    "Shop All Gear": "/collections/outdoor-dog-gear",
    "Raincoats": "/collections/dog-raincoats",
    "Suits": "/collections/suits-collection",
    "Parkas & Jackets": "/collections/dog-parkas-dog-jackets",
    "Sweaters & Hoodies": "/collections/dog-sweaters-dog-hoodies",
    "Hats & Accessories": "/collections/dog-accessories",
    "Human Apparel": "/collections/pet-parent",
    "Shop All Outerwear": "/collections/dog-outerwear",
  };

  const labelRewrites = {
    "Harness Guide": "Hands-Free Dog Walking",
    "Gift Cards": "Hot Weather Dog Apparel",
  };

  const cleanText = (value) => (value || "").replace(/\s+/g, " ").trim();
  const allProductsPattern = /\/collections\/all(?:[/?#]|$)/i;

  function injectProductShellStyles() {
    if (document.getElementById("cp-product-shell-restore-style")) return;

    const style = document.createElement("style");
    style.id = "cp-product-shell-restore-style";
    style.textContent = `
      .cp-js-product-shell-announcement {
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        background: #ffffff;
        text-align: center;
      }

      .cp-js-product-shell-announcement a {
        display: block;
        margin: 0 auto;
        padding: 11px 16px;
        color: #000000;
        font-size: 0.75rem;
        font-weight: 600;
        letter-spacing: 0.02em;
        text-decoration: none;
      }

      .cp-js-product-shell-header {
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        background: #ffffff;
      }

      .cp-js-product-shell-header__inner {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
        gap: 12px;
        max-width: 1360px;
        margin: 0 auto;
        padding: 14px 24px;
      }

      .cp-js-product-shell-header__action {
        display: inline-flex;
        align-items: center;
        color: #000000;
        text-decoration: none;
      }

      .cp-js-product-shell-header__action--search {
        justify-self: start;
      }

      .cp-js-product-shell-header__action--cart {
        justify-self: end;
        position: relative;
      }

      .cp-js-product-shell-header__logo-link {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
      }

      .cp-js-product-shell-header__logo-link img {
        display: block;
        height: auto;
        max-height: 36px;
        width: auto;
        max-width: min(220px, 48vw);
      }

      .cp-js-product-shell-header__logo-link svg {
        display: block;
        max-width: min(220px, 48vw);
        height: auto;
      }

      .cp-js-product-shell-header__cart-count {
        position: absolute;
        top: -5px;
        right: -8px;
        min-width: 18px;
        height: 18px;
        border-radius: 999px;
        background: #000000;
        color: #ffffff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0 5px;
        font-size: 10px;
        font-weight: 700;
        line-height: 1;
      }

      .cp-js-product-shell-footer {
        border-top: 1px solid rgba(0, 0, 0, 0.08);
        background: #ffffff;
      }

      .cp-js-product-shell-footer__inner {
        max-width: 1360px;
        margin: 0 auto;
        padding: 20px 16px 28px;
        text-align: center;
        color: rgba(0, 0, 0, 0.72);
        font-size: 0.75rem;
        line-height: 1.4;
      }

      @media screen and (max-width: 749px) {
        .cp-js-product-shell-header__inner {
          padding: 12px 16px;
        }

        .cp-js-product-shell-header__logo-link img,
        .cp-js-product-shell-header__logo-link svg {
          max-height: 28px;
          max-width: min(180px, 44vw);
        }
      }
    `;

    document.head.appendChild(style);
  }

  function getProductShellLogoMarkup() {
    const logoLink = document.querySelector(".cp-header__brand-link");
    if (!logoLink) return "<span>My Store</span>";
    return logoLink.innerHTML.trim();
  }

  function getProductShellCartCount() {
    const cartCount = document.querySelector(".cp-header__cart-count");
    return cartCount ? cartCount.textContent.trim() : "";
  }

  function restoreProductShell() {
    if (document.body.dataset.cpProductShellRestored === "true") return;

    injectProductShellStyles();

    const logoMarkup = getProductShellLogoMarkup();
    const cartCount = getProductShellCartCount();
    const year = new Date().getFullYear();

    const announcementSection = document.querySelector(".cp-announcement")?.closest(".shopify-section");
    if (announcementSection) {
      announcementSection.innerHTML = `
        <div class="cp-js-product-shell-announcement">
          <a href="/collections/shop-all">FREE SHIPPING ON ALL ORDERS</a>
        </div>
      `;
    }

    const headerSection = document.querySelector(".cp-header")?.closest(".shopify-section");
    if (headerSection) {
      headerSection.innerHTML = `
        <header class="cp-js-product-shell-header">
          <div class="cp-js-product-shell-header__inner">
            <a class="cp-js-product-shell-header__action cp-js-product-shell-header__action--search" href="/search" aria-label="Search">
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M22.277 20.83C23.052 21.596 21.889 22.745 21.113 21.98L17.061 17.977C16.286 17.211 12.753 13.738 13.529 14.504L14.715 13.362L22.277 20.83ZM13.551 14.51A7.796 7.796 0 0 1 8.671 16.214C4.38 16.214 0.9 12.778 0.9 8.54C0.9 4.302 4.382 0.866 8.672 0.866C12.962 0.866 16.441 4.302 16.441 8.54A7.584 7.584 0 0 1 14.716 13.362L18.226 16.828L17.062 17.978L13.551 14.51ZM14.794 8.56C14.794 5.22 12.052 2.511 8.671 2.511C5.29 2.511 2.548 5.22 2.548 8.56C2.548 11.9 5.29 14.609 8.671 14.609C12.052 14.609 14.794 11.9 14.794 8.56Z" fill="currentColor"/>
              </svg>
            </a>
            <a class="cp-js-product-shell-header__logo-link" href="/" aria-label="My Store">${logoMarkup}</a>
            <a class="cp-js-product-shell-header__action cp-js-product-shell-header__action--cart" href="/cart" aria-label="Cart">
              <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M8.938 20.864A1.703 1.703 0 1 1 5.532 20.864A1.703 1.703 0 0 1 8.938 20.864ZM20.45 20.864A1.703 1.703 0 1 1 17.045 20.864A1.703 1.703 0 0 1 20.45 20.864ZM22.45 5.255C23.322 5.255 23.998 6.024 23.884 6.889L22.664 15.989C22.57 16.665 21.995 17.16 21.314 17.16H6.915C6.246 17.16 5.678 16.684 5.57 16.024L3.628 4.243H1.154C0.517 4.243 0 3.728 0 3.093C0 2.458 0.517 1.943 1.154 1.943H4.603C5.173 1.943 5.66 2.353 5.756 2.913L5.991 4.243H22.45ZM21.514 7.555H6.359L7.983 14.86H20.31L21.514 7.555Z" fill="currentColor"/>
              </svg>
              ${
                cartCount
                  ? `<span class="cp-js-product-shell-header__cart-count">${cartCount}</span>`
                  : ""
              }
            </a>
          </div>
        </header>
      `;
    }

    const footerSection = document.querySelector(".cp-footer")?.closest(".shopify-section");
    if (footerSection) {
      footerSection.innerHTML = `
        <div class="cp-js-product-shell-footer">
          <div class="cp-js-product-shell-footer__inner">&copy; Copyright ${year}</div>
        </div>
      `;
    }

    document.documentElement.classList.remove("cp-drawer-open");
    document.body.classList.remove("cp-drawer-open");
    document.body.dataset.cpProductShellRestored = "true";
  }

  function patchAnnouncement() {
    const announcement = document.querySelector(".cp-announcement__message");
    if (!announcement) return;

    const text = cleanText(announcement.textContent);
    const href = announcement.getAttribute("href") || "";

    if (/fireworks/i.test(text) || allProductsPattern.test(href)) {
      announcement.textContent = "FREE SHIPPING ON ALL ORDERS";
      announcement.setAttribute("href", routes.announcement);
    }
  }

  function patchLinks() {
    const selectors = [
      ".cp-header__nav-link",
      ".cp-drawer__link",
      ".cp-mobile-quicklinks__link",
      ".cp-header__mega-link",
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((link) => {
        const currentHref = link.getAttribute("href") || "";
        if (!allProductsPattern.test(currentHref)) return;

        const rawLabel = cleanText(link.textContent);
        const nextLabel = labelRewrites[rawLabel] || rawLabel;
        const nextHref = linkMap[nextLabel];

        if (!nextHref) return;

        if (nextLabel !== rawLabel) {
          link.textContent = nextLabel;
        }

        link.setAttribute("href", nextHref);
      });
    });
  }

  function patchSearchButton() {
    document.querySelectorAll('.cp-header__actions button[aria-label="Search"]').forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = routes.search;
      });
    });
  }

  function normalizePdpVariantButtons() {
    document
      .querySelectorAll('variant-picker[data-template-product-match="true"] fieldset.variant-option--swatches')
      .forEach((fieldset) => {
        fieldset.classList.remove("variant-option--swatches");
        fieldset.classList.add("variant-option--equal-width-buttons");

        const legendValue = fieldset.querySelector(".variant-option__swatch-value");
        if (legendValue) {
          legendValue.remove();
        }

        fieldset.querySelectorAll("label").forEach((label) => {
          label.classList.remove("variant-option__button-label--has-swatch");

          const input = label.querySelector("input");
          const visibleText = cleanText(
            label.querySelector(".variant-option__button-label__text")?.textContent ||
              label.querySelector(".visually-hidden")?.textContent ||
              input?.value ||
              input?.getAttribute("aria-label") ||
              ""
          ).replace(/\s+-\s+Sold out$/i, "");

          label.querySelectorAll(".swatch, .visually-hidden").forEach((node) => node.remove());

          if (input?.dataset.optionAvailable === "true" && !label.querySelector(".variant-option__button-label__pill")) {
            const pill = document.createElement("span");
            pill.className = "variant-option__button-label__pill";
            pill.dataset.key = "variant-option-pill";
            label.appendChild(pill);
          }

          let textNode = label.querySelector(".variant-option__button-label__text");
          if (!textNode) {
            textNode = document.createElement("span");
            textNode.className = "variant-option__button-label__text";
            textNode.dataset.key = "variant-option-text";
            label.appendChild(textNode);
          }

          textNode.textContent = visibleText;
        });
      });
  }

  function watchPdpVariantButtons() {
    const picker = document.querySelector('variant-picker[data-template-product-match="true"]');
    if (!picker || picker.dataset.cpVariantButtonsObserved === "true") return;

    picker.dataset.cpVariantButtonsObserved = "true";

    const observer = new MutationObserver(() => {
      normalizePdpVariantButtons();
    });

    observer.observe(picker, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  function injectPdpBuyButtonBorders() {
    if (!document.querySelector(".product-details")) return;
    if (document.getElementById("cp-pdp-buy-border-fix")) return;

    const style = document.createElement("style");
    style.id = "cp-pdp-buy-border-fix";
    style.textContent = `
      .product-details {
        --cp-pdp-control-border: rgba(0, 0, 0, 0.18);
        --cp-pdp-control-border-strong: rgba(0, 0, 0, 0.72);
      }

      .product-details .variant-option__button-label {
        align-items: center;
        background: #ffffff;
        border: 1px solid var(--cp-pdp-control-border);
        border-radius: 999px;
        color: #000000;
        display: inline-flex;
        justify-content: center;
        min-height: 44px;
        padding: 0 18px;
        transition:
          background-color 0.2s ease,
          border-color 0.2s ease,
          color 0.2s ease,
          box-shadow 0.2s ease;
      }

      .product-details .variant-option__button-label:hover {
        background: rgba(0, 0, 0, 0.04);
        border-color: rgba(0, 0, 0, 0.28);
      }

      .product-details .variant-option__button-label:has(input:checked) {
        background: #000000;
        border-color: var(--cp-pdp-control-border-strong);
        color: #ffffff;
      }

      .product-details .variant-option__button-label:has(input:focus-visible) {
        outline: 2px solid rgba(0, 0, 0, 0.24);
        outline-offset: 2px;
      }

      .product-details .product-form-buttons .quantity-selector {
        border: 1px solid var(--cp-pdp-control-border);
        background: #ffffff;
        border-radius: 999px;
        overflow: hidden;
        min-height: 48px;
      }

      .product-details .product-form-buttons .quantity-selector input {
        background: transparent;
        border: 0;
        color: #000000;
        min-width: 44px;
      }

      .product-details .product-form-buttons .quantity-minus,
      .product-details .product-form-buttons .quantity-plus {
        min-width: 44px;
        position: relative;
        width: 44px;
      }

      .product-details .product-form-buttons .quantity-minus::after,
      .product-details .product-form-buttons .quantity-plus::before {
        content: "";
        position: absolute;
        top: 10px;
        bottom: 10px;
        width: 1px;
        background: var(--cp-pdp-control-border);
      }

      .product-details .product-form-buttons .quantity-minus::after {
        inset-inline-end: 0;
      }

      .product-details .product-form-buttons .quantity-plus::before {
        inset-inline-start: 0;
      }

      .product-details .product-form-buttons .add-to-cart-button,
      .sticky-add-to-cart__button.add-to-cart-button {
        border: 1px solid var(--cp-pdp-control-border);
        background: #ffffff;
        border-radius: 999px;
        box-shadow: none;
        color: #000000;
        min-height: 48px;
        transition:
          background-color 0.2s ease,
          border-color 0.2s ease,
          color 0.2s ease;
      }

      .product-details .product-form-buttons .add-to-cart-button:hover,
      .sticky-add-to-cart__button.add-to-cart-button:hover {
        background: #000000;
        border-color: var(--cp-pdp-control-border-strong);
        color: #ffffff;
      }

      .product-details .product-form-buttons .add-to-cart-button .add-to-cart-text,
      .product-details .product-form-buttons .add-to-cart-button .add-to-cart-icon,
      .sticky-add-to-cart__button.add-to-cart-button .add-to-cart-text,
      .sticky-add-to-cart__button.add-to-cart-button .add-to-cart-icon {
        color: inherit;
      }
    `;

    document.head.appendChild(style);
  }

  function run() {
    if (isProductPage) {
      restoreProductShell();
      normalizePdpVariantButtons();
      watchPdpVariantButtons();
      injectPdpBuyButtonBorders();
      return;
    }

    patchAnnouncement();
    patchLinks();
    patchSearchButton();
    normalizePdpVariantButtons();
    watchPdpVariantButtons();
    injectPdpBuyButtonBorders();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }
})();
